import { SearchResult } from "@iventis/domain-model/model/searchResult";
import { Sitemap } from "@iventis/domain-model/model/sitemap";
import { ReactNode } from "react";
import { SearchResultGroupInterface } from "../interface/search-result-interface";
import { SearchResultType, SitemapSearchOptions } from "../types/types";

export class SitemapSearchResult extends SearchResultGroupInterface<Sitemap> {
    constructor(name: string, type: SearchResultType, icon: ReactNode, onResultClicked: (result: Sitemap) => void, options: SitemapSearchOptions) {
        super(name, type, icon, onResultClicked);
        this.getSitemaps = options.getSitemaps;
    }

    private readonly getSitemaps: () => Sitemap[];

    public async getResults(searchString: string): Promise<{ type: SearchResultType; results: SearchResult<Sitemap>[] }> {
        const sitemaps = this.getSitemaps();
        const lowerSearch = searchString.toLowerCase();
        const matched = sitemaps.filter((sitemap) => sitemap.name?.toLowerCase().includes(lowerSearch)).slice(0, 3);
        const results: SearchResult<Sitemap>[] = matched.map((sitemap) => ({
            displayText: sitemap.name,
            result: sitemap,
        }));
        return { type: this.type, results };
    }
}
